import { PaletteOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    primary: PaletteColor;
    secondary: PaletteColor;
    error: PaletteColor;
    grey2: PaletteColor;
    complementary: PaletteColor;
    orange: PaletteColor;
    yellow: PaletteColor;
    transparency: PaletteColor;
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    primary?: PaletteColorOptions;
    secondary?: PaletteColorOptions;
    error?: PaletteColorOptions;
    grey2?: PaletteColorOptions;
    complementary?: PaletteColorOptions;
    orange?: PaletteColorOptions;
    yellow?: PaletteColorOptions;
    transparency?: PaletteColorOptions;
  }

  interface PaletteColor {
    main: string;
    dark: string;
    darker?: string;
    moreDarker?: string;
    darkest?: string;
    light: string;
    lighter?: string;
    moreLighter?: string;
    lightest?: string;
    contrastText: string;
    lightest2?: string;
  }
}

export const muiTextFieldTheme = {
  styleOverrides: {
    root: (props: any) => {
      const { palette, typography }: { palette: PaletteOptions | any; typography: any } = props.theme;
      const paragraphDefaultTypography = typography.paragraphDefault;
      const captionTypography = typography.caption;
      return {
        "& .MuiInputLabel-filled": {
          ...paragraphDefaultTypography,
          color: `${palette.grey2.light} !important`,
          paddingLeft: "6px",
          paddingTop: "4px",
        },
        "& MuiFilledInput-root": {
          border: "none",
        },
        "& .MuiFormHelperText-root": {
          ...captionTypography,
          color: palette.grey2.light,
          marginTop: "4px !important",
          marginLeft: "16px",
          marginRight: "16px",
          "&.Mui-error": {
            color: palette.error.main,
          },
        },
        "& .MuiInputBase-multiline": {
          paddingLeft: "0px !important",
          marginBottom: "4px !important",
          paddingTop: "0px !important",
        },
        "& .MuiInputBase-multiline.Mui-focused": {
          marginBottom: "3px !important",
        },
        "& .MuiInputBase-input": {
          padding: "30px 16px 10px 16px",
          "&.Mui-disabled": {
            WebkitTextFillColor: palette.grey2.darker,
          },
        },
        "& .MuiInputLabel-shrink": {
          lineHeight: "20px !important",
          paddingTop: "6px !important",
          marginTop: "0px !important",
        },
        "& input:focus": {
          paddingLeft: "15px",
        },
        "& textarea:focus": {
          paddingTop: "29px !important",
          paddingLeft: "15px !important",
        },
        "& .MuiFilledInput-root": {
          backgroundColor: palette.common.white,
          border: `1px solid ${palette.grey2.lighter}`,
          overflow: "hidden",
          borderRadius: 12,
          height: "64px",
          "&.MuiInputBase-multiline": {
            minHeight: "112px",
            height: "auto",
            "& textarea": {
              height: "unset !important",
              paddingTop: "0px !important",
            },
          },
          "&:hover": {
            backgroundColor: "white",
            borderColor: palette.grey2.light,
          },
          "&:before": {
            border: "none !important",
          },
          "&:after": {
            border: "none !important",
          },
          "&.Mui-focused": {
            backgroundColor: "white",
            borderWidth: "2px",
            borderColor: palette.grey2.main,
            "& .MuiSelect-select": {
              paddingLeft: "15px !important",
              background: "white",
            },
            "& .MuiSelect-icon": {
              right: 19,
            },
            "& .MuiSelect-select p": {
              marginRight: 39,
            },
          },
          "&.Mui-error": {
            backgroundColor: "white",
            borderColor: palette.error.main,
          },
          "& .themeInputAdornment > .MuiTypography-caption": {
            paddingRight: "10px",
            cursor: "pointer",
          },
          "& .themeInputAdornment > .MuiSvgIcon-root": {
            color: palette.primary.main,
            cursor: "pointer",
          },
          "&.Mui-disabled": {
            backgroundColor: palette.grey2.lightest2,
            borderColor: palette.grey2.moreLighter,
            "& .themeInputAdornment > .MuiSvgIcon-root": {
              color: palette.grey2.light,
              cursor: "default !important",
            },
            "& .themeInputAdornment > .MuiButton-root": {
              backgroundColor: palette.grey2.light,
              cursor: "default !important",
            },
          },
          "& input::placeholder": {
            ...paragraphDefaultTypography,
            color: palette.grey2.lighter,
            opacity: 1,
            paddingLeft: "0px",
          },
          "& .MuiSelect-select p": {
            WebkitLineClamp: "1",
            marginRight: 40,
          },
          "& .MuiSelect-icon": {
            right: 20,
            top: "calc(50% - 12px)",
          },
        },
      };
    },
  },
};
